import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    // Prod DB

    apiKey: "AIzaSyCdLsoJvys7rTV4TD0tNlqWxvOD6PP4hXI",
    authDomain: "baglami-83fc7.firebaseapp.com",
    projectId: "baglami-83fc7",
    storageBucket: "baglami-83fc7.firebasestorage.app",
    messagingSenderId: "694452420376",
    appId: "1:694452420376:web:d5d29d05cc2f4a5f18e86d",
    measurementId: "G-JXEDBZ4RVR"
};


// 🔥 Initialize app FIRST
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// 🔥 Then initialize Firestore
const db = getFirestore(app);

// ✅ Export AFTER initialization
export { db, auth };
